import { getReservedBlogCategoryIds } from './getReservedBlogCategoryIds'

/** True when `_id` is one of the two reserved categories (Uncategorized, What's New) of the tenant, or the tenant-free pair when there is no tenant id. */
export function isReservedBlogCategoryId(_id: string | null | undefined, tenantId?: string | null): boolean {
  const { uncategorized, whatsNew } = getReservedBlogCategoryIds(tenantId)

  return _id === uncategorized || _id === whatsNew
}
